import styled, { css } from 'styled-components';

export const CommonBlock = styled.div`
  // 552px
  // 28px 0px 45px 16px
  width: 100%;
  padding: 28px 0px 52px 8px;
  @media (min-width: 640px) {
    padding: 28px 0px 52px 16px;
  }
`;

export const ContainerCard = styled.div`
  padding: 16px;
  borderradius: 4px;
  background-color: #fff;
  border-radius: 8px;
  width: 100%;

  .section__container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .section__container--contact {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 232px;
  }

  .section__container--campus {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 232px;
  }

  .section__container--paragraph {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
  }

  .help__contact {
    display: flex;
    gap: 5px;

    p {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #4f6168;
    }
  }

  .section__delivery {
    border: 1px solid #a8cbe2;
    border-radius: 4px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    .section__delivery--title {
      display: flex;
      gap: 8px;
      padding: 8px 13px 8px 8px;

      .container__rb {
        display: block;
        position: relative;
        padding-left: 25px;
        cursor: pointer;
        font-weight: 700;
        font-size: 12px;
        line-height: 16px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .container__rb input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
      }

      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 17px;
        width: 17px;
        background-color: #fff;
        border-radius: 50%;
        border: 1px solid #283044;
      }

      .container__rb:hover input ~ .checkmark {
        background-color: #d5e5f0;
      }

      .container__rb input:checked ~ .checkmark {
        background-color: #4318cd;
        border: 1px solid #4318cd;
      }

      .checkmark:after {
        content: '';
        position: absolute;
        display: none;
      }

      .container__rb input:checked ~ .checkmark:after {
        display: block;
      }

      .container__rb .checkmark:after {
        top: 2.5px;
        left: 2.5px;
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background: white;
      }
    }

    .districts {
      display: flex;
      flex-direction: column;
      padding: 8px 13px 8px 8px;
      gap: 4px;
      width: 100%;

      p {
        font-weight: 500;
        font-size: 11px;
        line-height: 16px;
        color: #4f6168;
      }
    }

    .section__direction {
      display: flex;
      flex-direction: column;
      padding: 8px 13px 8px 8px;
      gap: 4px;
      width: 100%;

      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #161d1f;
      }
    }

    .section__reference {
      display: flex;
      flex-direction: column;
      padding: 8px 13px 8px 8px;
      gap: 4px;
      width: 100%;

      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #161d1f;
      }
    }
  }

  .section__campus {
    border: 1px solid #a8cbe2;
    border-radius: 4px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    .section__campus--title {
      display: flex;
      gap: 8px;
      padding: 8px 13px 8px 8px;

      .container__rb {
        display: block;
        position: relative;
        padding-left: 25px;
        cursor: pointer;
        font-weight: 700;
        font-size: 12px;
        line-height: 16px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .container__rb input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
      }

      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 17px;
        width: 17px;
        background-color: #fff;
        border-radius: 50%;
        border: 1px solid #283044;
      }

      .container__rb:hover input ~ .checkmark {
        background-color: #d5e5f0;
      }

      .container__rb input:checked ~ .checkmark {
        background-color: #4318cd;
        border: 1px solid #4318cd;
      }

      .checkmark:after {
        content: '';
        position: absolute;
        display: none;
      }

      .container__rb input:checked ~ .checkmark:after {
        display: block;
      }

      .container__rb .checkmark:after {
        top: 2.5px;
        left: 2.5px;
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background: white;
      }
    }

    .section__campus--subtitle {
      display: flex;
      flex-direction: column;
      gap: 4px;
      // align-items: center;
      width: 100%;
      margin-left: 30px;

      .section__campus--paragraph {
        font-weight: 900;
        font-size: 14px;
        line-height: 20px;
        color: #161d1f;
      }

      .section__campus--paragraphv2 {
        font-weight: 500;
        font-size: 11px;
        line-height: 16px;
        color: #4f6168;
      }
    }
  }

  .section__contact--input {
    border: 1px solid #7a959f;
    border-radius: 4px;
    padding: 8px 8px 8px 16px;

    ::placeholder {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #8090bb;
    }
  }
`;

export const RegisterBtn = styled.button.attrs((props: any) => ({
  phone: props.phone,
  direction: props.direction,
  detail: props.detail,
  deliveryMode: props.deliveryMode,
  isProvince: props.isProvince,
  districtId: props.districtId,
  resultFormPrint: props.resultFormPrint
}))`
  ${(props) => {
    // casoRecojo
    const validButton = css`
      width: 100%;
      background: ${props.phone === 9 ? '#5B36F2' : '#d5e5f0'};
      border-radius: 4px;
      padding: 10px 16px;
      margin-top: 16px;
      cursor: ${props.phone === 9 ? 'pointer' : 'default'};
      pointer-events: ${props.phone === 9 ? 'initial' : 'none'};

      p {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: ${props.phone === 9 ? '#FFFFFF' : '#8090bb'};
      }

      &:hover {
        transition: background 400ms ease-in-out;
        background: #4318cd;
      }

      &:focus {
        transition: background 400ms ease-in-out;
        background: #4318cd;
      }

      &:active {
        transition: background 0ms ease-in-out;
        background-color: #4318cd;
      }
    `;

    // casoDelivery
    const disabledButton = css`
      width: 100%;
      background: ${props.phone === 9 &&
      props.deliveryMode !== 0 &&
      props.districtId &&
      props.direction !== 0 &&
      props.detail > 0 &&
      props.detail < 101
        ? '#5B36F2'
        : '#d5e5f0'};
      border-radius: 4px;
      padding: 10px 16px;
      margin-top: 16px;
      cursor: ${props.phone === 9 &&
      props.deliveryMode !== 0 &&
      props.districtId &&
      props.direction !== 0 &&
      props.detail > 0 &&
      props.detail < 101
        ? 'pointer'
        : 'default'};
      pointer-events: ${props.phone === 9 &&
      props.deliveryMode !== 0 &&
      props.districtId &&
      props.direction !== 0 &&
      props.detail > 0 &&
      props.detail < 101
        ? 'initial'
        : 'none'};

      p {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: ${props.phone === 9 &&
        props.deliveryMode !== 0 &&
        props.districtId &&
        props.direction !== 0 &&
        props.detail > 0 &&
        props.detail < 101
          ? '#FFFFFF'
          : '#8090bb'};
      }

      &:hover {
        transition: background 400ms ease-in-out;
        background: #4318cd;
      }

      &:focus {
        transition: background 400ms ease-in-out;
        background: #4318cd;
      }

      &:active {
        transition: background 0ms ease-in-out;
        background-color: #4318cd;
      }
    `;

    switch (props.resultFormPrint()) {
      case 'P':
        return validButton;
      case 'B':
        return validButton;
      case 'A':
        return disabledButton;
      case 'C':
        return disabledButton;
      default:
        return css``;
    }
  }}

  @media (min-width: 640px) {
    width: 83px;
  }
`;
